import React, {forwardRef, useImperativeHandle, useRef, useState} from "react";
import AudioPlayer, {RHAP_UI} from "./react-h5-audio-player/src/index";
import './react-h5-audio-player/src/styles.scss';
import {getImagePath} from "../../../../../src/utils";
import {FROM_CANVAS} from "../../../../../src/Const";

const CustomAudio = forwardRef((props:{onMouseDown?:any,onMouseMove?:any,onMouseUp?:any,onWheel?:any,szUrl:any,from:any,onPlayUpdate?:any,height?:any}, ref) => {
    useImperativeHandle(ref,()=>({
        onGetCurrentTime:onGetCurrentTime,
        onSetCurrentTime:onSetCurrentTime,
        onPause:onPause,
        onPlay:onPlay,
        onGetDurationTime:onGetDurationTime,
    }))


    const onGetCurrentTime = ()=>{
        return h5AudioPlayerRef.current?.getCurrentPlayTime();
    }

    const onSetCurrentTime = (lTime:any)=>{
        return h5AudioPlayerRef.current?.setCurrentPlayTime(lTime);
    }

    const onPause = ()=>{
        h5AudioPlayerRef.current?.pause();
    }

    const onPlay = ()=>{
        h5AudioPlayerRef.current?.play();
    }

    const onGetDurationTime = ()=>{
        return h5AudioPlayerRef.current?.getDurationTime();
    }

    const h5AudioPlayerRef = useRef<any>(null);
    const [currentTime,setCurrentTime] = useState(0);
    const [totalTime,setTotalTime] = useState(0);
    return(
        <div style={{width: '100%', height: props.height || '100%', pointerEvents: 'all',fontSize:'14px',position:'relative'}}
             onMouseMove={props.onMouseMove}
             onMouseDown={props.onMouseDown}
             onMouseUp={props.onMouseUp}
             onWheel={props.onWheel}>

            <AudioPlayer
                // customProgressBarSection={[RHAP_UI.LEFT_PLAY, RHAP_UI.PROGRESS_BAR,RHAP_UI.VOLUME]}
                onRef={(ref)=>{
                    h5AudioPlayerRef.current = ref;
                }}
                style={{opacity:'1',fontSize:'14px',borderRadius:'8px'}}
                // customAdditionalControls={[]}
                // customControlsSection={[]}
                src={props.szUrl}
                onListen={(e)=>{
                    // console.log(e.currentTarget.currentTime)
                    if (props.onPlayUpdate) {
                        props.onPlayUpdate(e.currentTarget.currentTime.toFixed(0))
                    }
                }}
                onPlay={e => console.log("onPlay")}
                // other props here

            />
            {
                props.from != FROM_CANVAS &&
                <div style={{position:'absolute',left:'0',top:'0',width:'100%',height:'100%',borderRadius:'8px',border:'1px solid var(--border-color)',pointerEvents:'none'}}></div>
            }
        </div>
    )
})

export default CustomAudio;














